var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "preview-buttons-container d-flex" },
    [
      _c(
        _setup.draggable,
        {
          staticClass: "d-flex",
          attrs: {
            list: _setup.listPreview,
            disabled: !_setup.canReorderPreviews,
            animation: 200,
          },
          on: { start: _setup.onDragStart, end: _setup.onDragEnd },
        },
        _vm._l(_setup.listPreview, function (preview) {
          return _c(
            _setup.CButton,
            {
              key: preview.value,
              staticClass: "preview-button d-flex align-items-center",
              class:
                _setup.selectedPreview === Number(preview.value)
                  ? "selected"
                  : "secondary",
              style: _setup.canReorderPreviews ? { cursor: "grab" } : null,
              on: {
                click: function ($event) {
                  return _setup.onPreviewSelected(preview)
                },
              },
            },
            [
              _setup.canReorderPreviews
                ? _c("font-awesome-icon", {
                    staticClass: "mr-2",
                    staticStyle: { position: "relative", top: "-1px" },
                    attrs: { size: "sm", icon: ["fas", "grip-dots-vertical"] },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "preview-label" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_setup.getPreviewLabel(preview)) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _setup.canModifyPreview
                ? _c(
                    "div",
                    {
                      staticClass:
                        "preview-actions d-inline-flex align-items-center",
                    },
                    [
                      _c("font-awesome-icon", {
                        directives: [{ name: "tippy", rawName: "v-tippy" }],
                        staticClass: "ml-3",
                        attrs: {
                          size: "sm",
                          content: "Edit",
                          icon: ["fas", "pencil"],
                        },
                        on: {
                          click: function ($event) {
                            return _setup.onEditPreview(preview)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _setup.listPreview.length > 1
                        ? _c("font-awesome-icon", {
                            directives: [{ name: "tippy", rawName: "v-tippy" }],
                            staticClass: "ml-3",
                            attrs: {
                              size: "sm",
                              content: "Delete",
                              icon: ["fas", "trash"],
                            },
                            on: {
                              click: function ($event) {
                                return _setup.onDeletePreview(preview)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(_setup.CanvasToolbarTopPreviewButtonsEditModal, {
        ref: "editModalRef",
        on: { save: _setup.onSavePreview },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }